'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  padding: 0 2rem;\n'], ['\n  padding: 0 2rem;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BoothContent = _styledComponents2.default.div(_templateObject);

exports.default = BoothContent;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/booth/booth-content.js
// module id = 1333
// module chunks = 0